const INITIAL_STATE = {
  cpcsCategories: [],
};

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case 'GET_QUALIFICATIONS_DETAILS_FULFILLED':
      return {
        ...state,
        cpcsCategories: payload.data.categories,
      };
    default:
  }
  return state;
};
